"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _tinymce = _interopRequireDefault(require("tinymce"));

var _plugins = require("../constants/plugins");

var _fontsize = require("./fontsize");

var _font = require("./font");

var _lineheight = require("./lineheight");

var _block = require("./block");

var _controls = require("./controls");

var _alignment = require("./alignment");

var _lists = require("./lists");

var _indent = require("./indent");

var _codeblock = require("./codeblock");

var _keyboardEscape = require("./keyboardEscape");

function formattingPlugin(editor) {
  (0, _lineheight.addLineheightSelects)(editor);
  (0, _font.addFontSelects)(editor);
  (0, _fontsize.addFontSizeSelects)(editor);
  (0, _block.addBlockSelect)(editor);
  (0, _controls.addFormattingControls)(editor);
  (0, _alignment.addAlignmentControls)(editor);
  (0, _lists.addListButtons)(editor);
  (0, _indent.addIndentationControls)(editor);
  (0, _codeblock.initCodeblockPlugin)(editor);
  (0, _keyboardEscape.initKeyboardEscapePlugin)(editor);
}

_tinymce.default.PluginManager.add(_plugins.HS_FORMATTING, formattingPlugin);